import { useLeadsSheetStore } from "../../../../../stores/LeadsStore";
import { Group } from "@mantine/core";
import LeftSheet from "./Left/LeftSheet";
import { useEffect } from "react";
import { findProspect } from "../../../../../api/PRMAPI";
import RightSheet from "./Right/RightSheet";
import { parseProspectDatafields } from "../../utils";
import { useParams } from "react-router-dom";

const params = [
  {
    url: "activate",
    value: "api_key",
  },
  {
    url: "disableNav",
    value: "disable_nav",
  },
  {
    url: "disableHeading",
    value: "disable_heading",
  },
  {
    url: "disableActions",
    value: "disable_actions",
  },
  {
    url: "disableMobile",
    value: "disable_mobile",
  },
  {
    url: "disableSelections",
    value: "disable_selections",
  },
  {
    url: "allowSwitch",
    value: "allow_switch",
  },
];

const LeadSheetStandalone = ({ initializing }) => {
  const { contactId } = useParams();
  const current = useLeadsSheetStore((s) => s.current);
  const setCurrent = useLeadsSheetStore((s) => s.setCurrent);
  const setLoading = useLeadsSheetStore((s) => s.setLoading);
  const loading = useLeadsSheetStore((s) => s.loading);

  useEffect(() => {
    //#region Part disable
    document.body.style.overflow = "auto";
    const urlParams = new URLSearchParams(window.location.search);

    params.forEach((p) => {
      let v = urlParams.get(p.url);
      if (p.url === "allowSwitch") {
        localStorage.setItem(p.value, v ? v : "false");
      } else {
        localStorage.setItem(p.value, v ? v : localStorage.getItem(p.value));
      }
    });

    if (urlParams.get("activate") === "true") {
      localStorage.setItem("api_key", urlParams.get("apiKey"));
    }

    if (urlParams.get("clearAll") === "true") {
      params.forEach((p) => {
        localStorage.setItem(p.value, false);
      });
    }
    //#endregion
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  useEffect(() => {
    if (loading && contactId) {
      findProspect(contactId, true)
        .then((response) => {
          setCurrent({
            ...parseProspectDatafields(response.data.contact_profile),
            new_reply: false,
          });
        })
        .finally(() => setLoading(false));
    }
  }, [contactId, loading, setCurrent, setLoading]);

  useEffect(() => {
    setLoading(true);
  }, []);

  if (initializing || !current) {
    return;
  }
  return (
    <Group
      flex={"1 1 auto"}
      h={"100vh"}
      align="start"
      className="lead-sheet"
      wrap="nowrap"
      gap={0}
      bg={"var(--mantine-color-primary-2)"}
      style={{ borderRadius: 12 }}
    >
      <LeftSheet />
      <RightSheet />
    </Group>
  );
};

export default LeadSheetStandalone;
